import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Stack } from '@mui/material';
import { useRetention } from '../RetentionContext';
import StageTabs from '../components/StageTabs';
import TrackingStage from '../stages/TrackingStage';
import { getTracking } from '../../../redux/features/retentionSlice';
import PhaseHeader from '../components/PhaseHeader';

// Phase 3 — stages 8–13, the "Learning Journey" tab (§2.3). All live via TrackingStage (fields in constants/stageFields.js):
// 8 first feedback · 9–11 reports + share · 12 call attempts + exits · 13 renewal.
export default function Tracking() {
  const { courseEnrollmentId, currentStage, progressByStage } = useRetention();
  const dispatch = useDispatch();

  // stages 8–13 all read GET /retention/:id/tracking
  useEffect(() => {
    dispatch(getTracking(courseEnrollmentId));
  }, [dispatch, courseEnrollmentId]);

  return (
    <Stack gap={2.5}>
      <PhaseHeader phase={3} currentStage={currentStage} />
      <StageTabs
        phase={3}
        currentStage={currentStage}
        progressByStage={progressByStage}
        renderStage={(no) => <TrackingStage key={no} stageNo={no} />}
      />
    </Stack>
  );
}
